import { useCallback } from 'react';
import { useSaucerDispatch } from '../context';
import { appendChildren, insertAfter, insertBefore, moveByPath, removeById, } from '../slice/ast';
/**
 * Saucer AST modify actions
 */
export function useASTDispatchAction() {
    var dispatch = useSaucerDispatch();
    var dispatchInsertBefore = useCallback(function (targetPath, type, nodeId, cupName, attrs) {
        if (attrs === void 0) { attrs = {}; }
        dispatch(insertBefore({
            targetPath: targetPath,
            type: type,
            nodeId: nodeId,
            cupName: cupName,
            attrs: attrs,
        }));
    }, []);
    var dispatchInsertAfter = useCallback(function (targetPath, type, nodeId, cupName, attrs) {
        if (attrs === void 0) { attrs = {}; }
        dispatch(insertAfter({
            targetPath: targetPath,
            type: type,
            nodeId: nodeId,
            cupName: cupName,
            attrs: attrs,
        }));
    }, []);
    var dispatchAppendChildren = useCallback(function (targetPath, type, nodeId, cupName, attrs) {
        if (attrs === void 0) { attrs = {}; }
        dispatch(appendChildren({
            targetPath: targetPath,
            type: type,
            nodeId: nodeId,
            cupName: cupName,
            attrs: attrs,
        }));
    }, []);
    var dispatchRemoveNodeById = useCallback(function (nodeId) {
        dispatch(removeById({ nodeId: nodeId }));
    }, []);
    var dispatchMoveNodeByPath = useCallback(function (fromPath, toPath) {
        dispatch(moveByPath({ fromPath: fromPath, toPath: toPath }));
    }, []);
    return {
        dispatchInsertBefore: dispatchInsertBefore,
        dispatchInsertAfter: dispatchInsertAfter,
        dispatchAppendChildren: dispatchAppendChildren,
        dispatchRemoveNodeById: dispatchRemoveNodeById,
        dispatchMoveNodeByPath: dispatchMoveNodeByPath,
    };
}
